module.exports = __webpack_public_path__ + "img/avatar.7a6bc100.jpg";